document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ebc-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-ebc-track]');
    var section = carousel.closest('.ebc');
    var prevBtn = section.querySelector('[data-ebc-prev]');
    var nextBtn = section.querySelector('[data-ebc-next]');
    var dotsWrap = section.querySelector('[data-ebc-dots]');
    var cards = Array.prototype.slice.call(track.children);
    if (!cards.length) return;

    var activePage = 0;
    var manualInteraction = false;
    var scrollEndTimer;

    function pageCount() {
      var clientWidth = track.clientWidth;
      if (!clientWidth) return 1;
      var scrollable = track.scrollWidth - clientWidth;
      if (scrollable <= 4) return 1; // no meaningful overflow, allow for rounding
      return Math.ceil(scrollable / clientWidth) + 1;
    }

    function buildDots() {
      var count = pageCount();
      dotsWrap.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ebc__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', (function (idx) {
          return function () { goToPage(idx); };
        })(i));
        dotsWrap.appendChild(dot);
      }
      updateUI();
    }

    function updateUI() {
      var dots = dotsWrap.querySelectorAll('.ebc__dot');
      var count = dots.length;
      if (activePage > count - 1) activePage = count - 1;
      if (activePage < 0) activePage = 0;
      dots.forEach(function (d, i) {
        d.setAttribute('aria-current', i === activePage ? 'true' : 'false');
      });
      if (prevBtn) prevBtn.disabled = activePage <= 0;
      if (nextBtn) nextBtn.disabled = activePage >= count - 1;
    }

    function goToPage(page) {
      var count = pageCount();
      page = Math.max(0, Math.min(count - 1, page));
      activePage = page;
      manualInteraction = false; // button-driven scroll: scroll listener will ignore it
      track.scrollTo({ left: page * track.clientWidth, behavior: 'smooth' });
      updateUI();
    }

    // Only sync from scroll position when the person is actually dragging/swiping,
    // never during a button-triggered smooth-scroll animation (avoids race conditions
    // on wide layouts where the animation takes longer to settle).
    track.addEventListener('pointerdown', function () { manualInteraction = true; });
    track.addEventListener('touchstart', function () { manualInteraction = true; }, { passive: true });

    track.addEventListener('scroll', function () {
      if (!manualInteraction) return;
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(function () {
        var clientWidth = track.clientWidth || 1;
        activePage = Math.round(track.scrollLeft / clientWidth);
        updateUI();
        manualInteraction = false;
      }, 120);
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goToPage(activePage - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToPage(activePage + 1); });

    window.addEventListener('resize', function () {
      buildDots();
    });

    buildDots();
  });
});